import React from 'react';
import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import { MarketTicker } from '../components/MarketTicker';
import { AdPlaceholder } from '../components/AdPlaceholder';
import { SidebarMarketWidget } from '../components/SidebarMarketWidget';
import { Facebook, Twitter, Linkedin, Mail, Printer } from 'lucide-react';
export function Article() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 flex flex-col" data-id="element-353">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-354">
        <Header data-id="element-355" />
        <Navigation data-id="element-356" />
      </div>

      <MarketTicker data-id="element-357" />

      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-358">
        {/* Banner Ad */}
        <div className="py-6 flex justify-center" data-id="element-359">
          <AdPlaceholder width="w-full max-w-[728px]" height="h-[90px]" text="Advertisement" data-id="element-360" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-361">
          {/* LEFT COLUMN: Article Content */}
          <main className="lg:col-span-8" data-id="element-362">
            <h1 className="font-serif text-4xl md:text-[2.75rem] leading-tight text-gray-900 mb-6" data-id="element-363">
              Perdue Foods appoints Andy Urban as chief commercial officer
            </h1>

            <div className="mb-6" data-id="element-364">
              <img src="https://placehold.co/800x450/e2e8f0/475569?text=Andy+Urban" alt="Andy Urban" className="w-full h-auto object-cover" data-id="element-365" />
              <p className="text-sm text-gray-600 italic text-center mt-2" data-id="element-366">
                Andy Urban, chief commercial officer, Perdue Foods | Source:
                Perdue Foods
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-between border-b border-gray-200 pb-4 mb-6 gap-4" data-id="element-367">
              <div className="text-sm text-gray-600" data-id="element-368">
                04.08.2026 <span className="mx-2" data-id="element-369">|</span> By{' '}
                <a href="#" className="text-[#002f5f] hover:underline font-medium" data-id="element-370">
                  Rachael Oatman
                </a>
              </div>

              <div className="flex items-center gap-2" data-id="element-371">
                <button className="w-8 h-8 rounded-full bg-gray-500 hover:bg-gray-600 flex items-center justify-center text-white transition-colors" data-id="element-372">
                  <Facebook className="w-4 h-4 fill-current" data-id="element-373" />
                </button>
                <button className="w-8 h-8 rounded-full bg-gray-500 hover:bg-gray-600 flex items-center justify-center text-white transition-colors" data-id="element-374">
                  <Twitter className="w-4 h-4 fill-current" data-id="element-375" />
                </button>
                <button className="w-8 h-8 rounded-full bg-gray-500 hover:bg-gray-600 flex items-center justify-center text-white transition-colors text-xs font-bold" data-id="element-376">
                  in
                </button>
                <button className="w-8 h-8 rounded-full bg-gray-500 hover:bg-gray-600 flex items-center justify-center text-white transition-colors" data-id="element-377">
                  <Mail className="w-4 h-4" data-id="element-378" />
                </button>
                <button className="w-8 h-8 rounded-full bg-gray-500 hover:bg-gray-600 flex items-center justify-center text-white transition-colors" data-id="element-379">
                  <Printer className="w-4 h-4" data-id="element-380" />
                </button>
              </div>
            </div>

            <div className="prose prose-lg max-w-none text-gray-800 leading-relaxed space-y-6" data-id="element-381">
              <p data-id="element-382">
                SALISBURY, MD. — Perdue Foods appointed Andy Urban as chief
                commercial officer, effective immediately. In this role, he will
                lead the company's commercial organization to drive growth and
                strengthen customer partnerships, overseeing sales, marketing,
                customer development, revenue management and innovation.
              </p>
              <p data-id="element-383">
                "Andy is a proven commercial leader with a deep understanding of
                our business, our customers and consumers, and our culture,"
                said Kevin McAdams, president and chief executive officer of
                Perdue Farms. "His track record of driving growth, building
                high-performing teams and delivering results makes him
                exceptionally well-suited to lead our commercial organization as
                we continue to evolve and compete in a dynamic marketplace."
              </p>
              <p data-id="element-384">
                With more than 35 years of experience, Urban is seasoned in
                leading complex, multi-channel consumer packaged goods
                businesses, with deep expertise across retail, foodservice,
                club, mass, convenience, industrial and international markets.
              </p>
              <p data-id="element-385">
                Since joining Perdue in 2009, Urban has held a series of senior
                leadership roles spanning sales, general management and
                enterprise transformation. Most recently, he served as senior
                vice president of the transformation office, where he led
                initiatives to simplify company operation and improve execution.
                Previously, Urban served as senior vice president and general
                manager of Perdue Premium Meat Co., as well as senior vice
                president and general manager of the prepared foods and turkey
                businesses, where he led multi-billion-dollar portfolios with
                full profit and loss responsibility. Earlier in his career,
                Urban held senior sales leadership roles at Perdue, including
                leading retail sales across all major channels. Before joining
                the company, he worked at WhiteWave Foods and Con Agra Foods.
              </p>
              <p data-id="element-386">
                "I'm honored to step into this role at a pivotal time for
                Perdue," Urban said. "This company has a strong foundation, a
                powerful purpose and an incredible team. I look forward to
                working closely with our customers and associates to drive
                sustainable growth and deliver value across the business."
              </p>
            </div>

            <div className="flex flex-wrap gap-2 mt-10 mb-8" data-id="element-387">
              <a href="#" className="px-3 py-1 border border-gray-300 text-xs font-medium text-[#002f5f] uppercase hover:bg-gray-50 transition-colors" data-id="element-388">
                Companies
              </a>
              <a href="#" className="px-3 py-1 border border-gray-300 text-xs font-medium text-[#002f5f] uppercase hover:bg-gray-50 transition-colors" data-id="element-389">
                Perdue Farms
              </a>
              <a href="#" className="px-3 py-1 border border-gray-300 text-xs font-medium text-[#002f5f] uppercase hover:bg-gray-50 transition-colors" data-id="element-390">
                People
              </a>
            </div>

            <hr className="border-gray-200 mb-8" data-id="element-391" />

            {/* Related Articles */}
            <div data-id="element-392">
              <div className="w-16 h-1 bg-[#38bdf8] mb-4" data-id="element-393"></div>
              <h3 className="text-2xl font-serif text-gray-900 mb-6" data-id="element-394">
                Related Articles
              </h3>
              <ul className="space-y-4" data-id="element-395">
                <li data-id="element-396">
                  <a href="#" className="text-[#002f5f] hover:underline text-lg" data-id="element-397">
                    Pilgrim's Europe appoints Matt Lee as chief business officer
                  </a>
                </li>
                <li data-id="element-398">
                  <a href="#" className="text-[#002f5f] hover:underline text-lg" data-id="element-399">
                    Foster Farms appoints new chief commercial officer
                  </a>
                </li>
                <li data-id="element-400">
                  <a href="#" className="text-[#002f5f] hover:underline text-lg" data-id="element-401">
                    Perdue Farms hires chief commercial officer
                  </a>
                </li>
              </ul>
            </div>
          </main>

          {/* RIGHT COLUMN: Sidebar */}
          <aside className="lg:col-span-4 flex flex-col gap-8" data-id="element-402">
            <AdPlaceholder width="w-full" height="h-[250px]" text="Advertisement (300x250)" data-id="element-403" />

            {/* Subscribe Box */}
            <div className="bg-gray-100 border border-gray-200 p-6 text-center" data-id="element-404">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-405">
                Subscribe Today
              </h3>
              <p className="text-sm text-gray-700 mb-6" data-id="element-406">
                Get your FREE subscription to <em data-id="element-407">Meat+Poultry</em> for the
                latest coverage of ingredients, equipment, food safety, and
                more.
              </p>
              <button className="bg-[#38bdf8] text-white px-6 py-2 rounded font-semibold hover:bg-sky-500 transition-colors w-full max-w-[200px]" data-id="element-408">
                Subscribe
              </button>
            </div>

            <AdPlaceholder width="w-full" height="h-[250px]" text="Advertisement (300x250)" data-id="element-409" />

            <SidebarMarketWidget data-id="element-410" />

            {/* Popular Articles */}
            <div data-id="element-411">
              <div className="flex items-center gap-4 mb-6" data-id="element-412">
                <h3 className="text-sm font-medium text-[#e8734a] uppercase tracking-wider whitespace-nowrap" data-id="element-413">
                  Popular Articles
                </h3>
                <div className="h-px bg-gray-300 w-full" data-id="element-414"></div>
              </div>
              <ul className="space-y-5" data-id="element-415">
                <li data-id="element-416">
                  <a href="#" className="text-gray-900 hover:text-[#002f5f] font-serif text-lg leading-snug transition-colors" data-id="element-417">
                    Triumph Foods readies for $30 million expansion in Missouri
                  </a>
                </li>
                <li data-id="element-418">
                  <a href="#" className="text-gray-900 hover:text-[#002f5f] font-serif text-lg leading-snug transition-colors" data-id="element-419">
                    Chicken nuggets subject of public health alert over possible
                    lead contamination
                  </a>
                </li>
                <li data-id="element-420">
                  <a href="#" className="text-gray-900 hover:text-[#002f5f] font-serif text-lg leading-snug transition-colors" data-id="element-421">
                    Tyson Foods closing Georgia prepared foods plant
                  </a>
                </li>
                <li data-id="element-422">
                  <a href="#" className="text-gray-900 hover:text-[#002f5f] font-serif text-lg leading-snug transition-colors" data-id="element-423">
                    Hertzog Meat Co. expands with new Butler processing plant
                  </a>
                </li>
              </ul>
            </div>

            {/* Popular Galleries */}
            <div data-id="element-424">
              <div className="flex items-center gap-4 mb-6" data-id="element-425">
                <h3 className="text-sm font-medium text-[#e8734a] uppercase tracking-wider whitespace-nowrap" data-id="element-426">
                  Popular Galleries
                </h3>
                <div className="h-px bg-gray-300 w-full" data-id="element-427"></div>
              </div>
              <div className="space-y-6" data-id="element-428">
                <div className="flex gap-4 group cursor-pointer" data-id="element-429">
                  <img src="https://placehold.co/120x80/e2e8f0/475569?text=MLB" alt="MLB" className="w-24 h-16 object-cover flex-shrink-0" data-id="element-430" />
                  <div data-id="element-431">
                    <h4 className="font-serif text-[1.1rem] leading-tight text-gray-900 group-hover:text-[#002f5f] transition-colors mb-1" data-id="element-432">
                      MLB menu innovation hits a grand slam
                    </h4>
                    <p className="text-xs text-gray-600 line-clamp-2" data-id="element-433">
                      New items include locally-inspired dishes and global
                      cuisine.
                    </p>
                  </div>
                </div>
                <div className="flex gap-4 group cursor-pointer" data-id="element-434">
                  <img src="https://placehold.co/120x80/e2e8f0/475569?text=Bacon" alt="Bacon" className="w-24 h-16 object-cover flex-shrink-0" data-id="element-435" />
                  <div data-id="element-436">
                    <h4 className="font-serif text-[1.1rem] leading-tight text-gray-900 group-hover:text-[#002f5f] transition-colors mb-1" data-id="element-437">
                      Bacon formulations
                    </h4>
                    <p className="text-xs text-gray-600 line-clamp-2" data-id="element-438">
                      Snapshots of new belly-centric pork products.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>;
}